import { LIEN_HE, TEN_MIEN_SAPA } from '@sapa/shared'
import { chuHienTai } from './theo-nganh.ts'

/** Mọi chuỗi hiển thị của web quầy. Tiếng Việt có dấu, câu ngắn, không thuật ngữ IT. */
export const T = {
  appName: 'SAPA — Quản lý tiệm',
  brand: 'SAPA',
  close: 'Đóng',

  // Có bản mới của web quầy (docs/plans/nut-cap-nhat-ban-moi-web-quay.md)
  banMoiCo: 'Có bản mới của SAPA.',
  // Câu ngắn CHỈ cho màn Lịch dưới 340px (dải chỉ rộng 184px): một dòng thay vì hai. Không thay câu đầy đủ ở khổ khác.
  banMoiCoNgan: 'Có bản mới.',
  banMoiNut: 'Cập nhật',
  banMoiDang: 'Đang cập nhật…',
  banMoiMatMang: 'Chưa cập nhật được. Kiểm tra mạng rồi bấm lại.',

  // Khung
  navCalendar: 'Lịch hẹn',
  navMyCalendar: 'Lịch của tôi',
  navConfig: 'Cấu hình',
  pageCalendar: 'Lịch hẹn',
  pageConfig: 'Cấu hình tiệm',
  accountMenu: 'Tài khoản của bạn',

  // Màn đăng nhập — khối thương hiệu
  loginTagline: 'Sổ lịch hẹn của tiệm, gọn trong một màn hình.',
  // Chỉ hiện trên điện thoại, nơi khối giới thiệu bên trái bị ẩn (vòng 33 V2).
  loginShortPitch: 'Phần mềm đặt lịch hẹn cho cửa hàng dịch vụ.',
  loginPitch: 'Quầy đặt lịch cho khách, xếp nhân viên, thu tiền. Không trùng giờ, không sót khách.',
  // Phản ánh 25/09: nói rõ ai vào đây và mỗi người thấy gì (trước đây không nhắc tới vai nào).
  loginPoint1: 'Chủ tiệm: lịch, tiền, nhân viên của cả tiệm',
  loginPoint2: 'Lễ tân: đặt lịch, đón khách, thu tiền',
  loginPoint3: 'Nhân viên: lịch và hoa hồng của riêng mình',
  loginFooter: 'SAPA · Phần mềm đặt lịch hẹn cho cửa hàng dịch vụ',

  // Khối "Vì sao chọn SAPA?" dưới form đăng nhập, mọi khổ (chủ dự án 18/10, docs/plans/gioi-thieu-sapa-man-dang-nhap.md).
  // Chỉ nói điều LUÔN ĐÚNG cho mọi tiệm: không tin nhắc tự động (ADR-073), không thanh toán online, không số liệu.
  gioiThieuTieuDe: 'Vì sao chọn SAPA?',
  // Hai nút chuyển vùng chính <-> vùng phụ của màn đăng nhập (chủ dự án 18/10 tối, kế hoạch mục 12).
  gioiThieuMoNut: 'Xem SAPA làm được gì',
  gioiThieuVeDangNhap: 'Về đăng nhập',
  gioiThieuDiem: [
    { tieuDe: 'Không lo trùng lịch', cau: 'Máy tự chặn lịch trùng giờ của nhân viên.' },
    // Ý 2 nhắc Zalo CÓ CHỦ Ý: ứng dụng khách đã Live (chủ dự án báo 18/10). Chỉ tiêu đề này được nhắc; xem chu-gioi-thieu.test.ts.
    { tieuDe: 'Khách tự đặt trên Zalo', cau: 'Không cần cài ứng dụng, không cần tạo tài khoản.' },
    { tieuDe: 'Tiền rõ ràng, không sửa lén', cau: 'Hoá đơn huỷ vẫn lưu, chủ tiệm được báo.' },
    { tieuDe: 'Bật đúng thứ tiệm cần', cau: 'Chưa dùng thì tắt đi, màn hình gọn hơn.' },
  ],

  // Khối "Giá rõ ràng" ngay dưới khối giới thiệu (chủ dự án 18/10 chiều). Hàm nhận CHUỖI TIỀN ĐÃ ĐỊNH DẠNG
  // (tienVnd) và số tháng lấy từ @sapa/shared/gia-sapa — KHÔNG gõ cứng số tiền / số tháng trong chữ.
  // Không nêu giá 99.000 / miễn phí (chỉ nhóm thử kín), tin Zalo, dùng thử, so sánh, khuyến mãi.
  giaRoTieuDe: 'Giá rõ ràng',
  giaRoDong: (giaThang: string, dong: number, tang: number, tienNam: string, dung: number) => [
    { tieuDe: `${giaThang} / tháng`, cau: 'Cho mỗi cửa hàng, dùng đủ tính năng.' },
    {
      tieuDe: `Đóng ${dong} tháng, tặng ${tang} tháng`,
      cau: `Trả ${tienNam} được dùng ${dung} tháng.`,
    },
    {
      tieuDe: 'Không tính theo đầu người',
      cau: 'Thêm nhân viên hay chi nhánh, giá vẫn vậy.',
    },
  ],

  // SAPA đang miễn phí (chủ dự án 26/10, ADR-113): thay khối "Giá rõ ràng" ở màn Đăng nhập khi SAPA_DANG_MIEN_PHI.
  // Không nêu số tiền, số tháng, "mãi mãi", "dùng thử". Dòng 3 là lời hứa (Q-A2 duyệt): khớp bản nháp Điều khoản mục 5.
  mienPhiTieuDe: 'SAPA đang miễn phí',
  mienPhiDong: [
    { tieuDe: 'Không mất phí', cau: 'Cửa hàng dùng đủ tính năng, không cần chuyển khoản.' },
    {
      tieuDe: 'Không tính theo đầu người',
      cau: 'Đang miễn phí cả nhân viên và chi nhánh.',
    },
    {
      tieuDe: 'Có phí thì báo trước',
      cau: 'Khi SAPA thu phí, cửa hàng được báo trước. SAPA không tự trừ tiền.',
    },
  ],

  // Lịch
  jumpToday: 'Hôm nay',
  pickDate: 'Chọn ngày',
  // KH-GĐ2 4.2: một dòng thay bốn ô — "5 lịch · 2 đang làm · 1 xong".
  daySummary: (tong: number, dangLam: number, xong: number) =>
    `${tong}\u00A0lịch · ${dangLam}\u00A0đang làm · ${xong}\u00A0xong`,
  dayEmptyShort: 'Ngày này chưa có lịch.',
  lateTag: 'Trễ / chưa tới',
  lateBy: (phut: string) => `Trễ ${phut}`,
  notArrived: 'Chưa tới',
  checkoutBtn: 'Tính tiền',
  checkoutTitle: 'Tính tiền cho ai?',
  checkoutDoing: 'đang làm',
  checkoutNone: 'Chưa có khách nào cần tính tiền',
  checkoutNoneHint: 'Khách tới thì bấm “Khách đã tới” trên lịch là tính tiền được.',
  checkoutWalkIn: 'Khách không có lịch',
  checkoutWalkInHint: 'Chọn dịch vụ và người làm, rồi tính tiền như lịch thường.',
  // Thông tin đơn vị vận hành — màn đăng nhập (chủ dự án yêu cầu 28/09).
  // Khoảng trắng KHÔNG NGẮT ( ) giữ từng cụm trên một dòng: chỉ xuống dòng sau dấu phẩy (chủ dự án 28/09).
  companyOwnerLabel: 'Đơn vị vận hành',
  companyName: 'CÔNG TY TNHH AUTOPOST VN',
  companyTaxLabel: 'Mã số thuế',
  companyTaxId: '0319267826',
  companyTaxShort: (mst: string) => `MST ${mst}`,
  companyAddressLabel: 'Địa chỉ',
  companyAddress: LIEN_HE.diaChi,
  statTotal: 'Tổng lịch',
  statWaiting: 'Chờ khách',
  statServing: 'Đang làm',
  statDone: 'Đã xong',
  staffCount: (n: number) => `${n}\u00A0lịch`,
  emptyDayTitle: 'Chưa có lịch nào trong ngày',
  // Hai câu theo cờ Live (1.5): chưa chạy thật trên Zalo thì không hứa "khách đặt qua Zalo".
  emptyDayHint: 'Khách đặt qua Zalo sẽ hiện ở đây. Bạn cũng có thể đặt hộ khách gọi điện tới.',
  emptyDayHintChuaLive: 'Chưa có lịch nào. Bạn đặt lịch cho khách ngay ở quầy.',
  closedTitle: 'Tiệm nghỉ ngày này',
  closedHint:
    'Ngày này chưa có giờ mở cửa. Bạn chọn ngày khác, hoặc sửa giờ mở cửa trong Cấu hình.',
  noStaffTitle: 'Chưa có ai trong ca',
  noStaffHint: 'Xếp ca cho nhân viên trước, khách mới đặt được giờ.',
  // Thợ (kỹ thuật viên) không có ca: câu riêng, không bảo thợ làm việc của chủ tiệm (ui-critic v45).
  noShiftMineTitle: 'Hôm nay bạn không có ca',
  noShiftMineOtherDayTitle: 'Ngày này bạn không có ca',
  noShiftMineHint: 'Bạn chọn ngày khác để xem lịch của mình.',
  closedHintTho: 'Tiệm chưa mở cửa ngày này. Bạn chọn ngày khác để xem lịch của mình.',
  goConfig: 'Mở Cấu hình',
  notReadyTitle: 'Tiệm chưa sẵn sàng nhận lịch',
  notReadyHint:
    'Chủ tiệm cần thêm chi nhánh, dịch vụ và nhân viên trước. Bạn nhờ chủ tiệm giúp nhé.',
  legend: 'Chú giải màu',
  detailTitle: 'Chi tiết lịch hẹn',
  detailCode: 'Mã lịch',
  detailTime: 'Thời\u00A0gian',
  detailService: 'Dịch vụ',
  detailPrice: 'Giá',
  detailPhone: 'Số điện thoại',
  get detailStaff() {
    return chuHienTai().nhanVien
  },
  detailNoPhone: 'Chưa có số',
  moreActions: 'Việc khác',
  confirmCancel: 'Chắc chắn huỷ lịch này?',
  confirmCancelYes: 'Huỷ lịch',
  confirmNoShow: 'Đánh dấu khách không đến?',
  confirmNoShowYes: 'Khách không đến',
  // K4 (v0.22.2): khách đang làm mà bỏ về — đóng lịch, không tính tiền. Nút xác nhận là "Đóng lịch" (không phải "Huỷ lịch": hộp hỏi "đóng lịch").
  confirmLeftMidway: 'Đóng lịch này, không tính tiền?',
  // Chỉ thêm khi tiệm CÓ mục Tiền cọc ở tờ chi tiết (M-N1: cọc của khách về giữa chừng chỉ hoàn, không giữ).
  confirmLeftMidwayCoc: 'Có tiền cọc thì hoàn lại cho khách ở mục Tiền cọc.',
  confirmLeftMidwayYes: 'Đóng lịch',
  keepIt: 'Không, giữ lại',
  noNextStep: 'Lịch này đã xong, không còn việc gì phải làm.',
  notYetDay: 'Chưa tới ngày hẹn. Đến hôm đó bạn bấm "Khách đã tới" khi khách vào tiệm.',
  unassigned: 'Chưa xếp người',
  zaloGuest: 'Khách Zalo',
  checkedInToast: (ten: string) => `Đã ghi: ${ten} đã tới`,
  undo: 'Hoàn tác',
  reschedule: 'Đổi giờ',
  viewOnCalendarShort: 'Xem lịch',
  clearSearchAndFilters: 'Xoá tìm và bộ lọc',
  viewOnCalendar: 'Xem trên lịch',
  navList: 'Danh sách',
  pageList: 'Danh sách lịch hẹn',
  // Ngắn để không cụt trên điện thoại (ui-critic v25); aria-label dùng cùng câu.
  searchPlaceholder: 'Tên, điện thoại, mã lịch',
  searchNoPhone: 'Tìm tên khách hoặc mã lịch',
  rangeToday: 'Hôm nay',
  rangeTomorrow: 'Ngày mai',
  rangeNext7: '7 ngày tới',
  rangeNext30: '30 ngày tới',
  rangePast7: '7 ngày qua',
  rangePickDay: 'Chọn ngày',
  statusAll: 'Tất cả',
  statusArrivedShort: 'Đã tới',
  statusMore: 'Thêm',
  statusLess: 'Thu gọn',
  // Chip gấp ô chọn Kỹ thuật viên ở điện thoại hẹp (màn Danh sách; chi nhánh nay ở dòng tên tiệm — ADR-101).
  filterBtn: 'Lọc',
  get allStaff() {
    return chuHienTai().moiNhanVien
  },
  dayCount: (n: number) => `${n}\u00A0lịch`,
  dayGroup: (ngay: string, n: number) => `${ngay} · ${n}\u00A0lịch`,
  listEmptyTitle: 'Không có lịch nào khớp',
  listEmptyHint: 'Bạn thử khoảng ngày khác, hoặc bỏ bớt bộ lọc.',
  clearFilters: 'Bỏ bộ lọc',
  loadMore: 'Xem thêm',
  colTime: 'Giờ',
  colCustomer: 'Khách',
  colService: 'Dịch vụ',
  get colStaff() {
    return chuHienTai().nhanVien
  },
  colPrice: 'Giá',
  colStatus: 'Trạng thái',
  sourceMiniapp: 'Zalo',
  sourceCounter: 'Tại quầy',
  rescheduleTitle: 'Đổi giờ lịch hẹn',
  nowAt: (gio: string) => `đang hẹn ${gio}`,
  moveTo: (gio: string, ngay: string) => `Dời sang ${gio} · ${ngay}`,
  moving: 'Đang dời…',
  moveFailed: 'Không dời được lịch. Bạn thử lại nhé.',
  movedToast: (ten: string) => `Đã dời lịch của ${ten}`,
  // K1a: sau khi huỷ / từ chối / dời, quầy đọc một câu THẬT khách được báo bằng cách nào (nhãn từ máy chủ).
  daHuyToast: (ten: string) => `Đã huỷ lịch của ${ten}`,
  daTuChoiToast: (ten: string) => `Đã từ chối lịch của ${ten}`,
  baoKhachZalo: 'Khách sẽ nhận tin Zalo báo việc này.',
  baoKhachTrongApp: 'Khách thấy tin khi mở trang đặt lịch của tiệm. Cần gấp thì bạn gọi khách.',
  baoKhachGoi: 'Khách chưa dùng trang đặt lịch của tiệm — bạn gọi báo khách nhé.',
  baoKhachChuaSo: 'Khách chưa cho số — chỉ thấy tin khi mở trang đặt lịch của tiệm.',
  dragHint: 'Kéo khối lịch để đổi giờ hoặc đổi người · chạm ô trống để thêm lịch',
  legendWaiting: 'Chờ duyệt / chờ cọc',
  noSlotForStaff: 'Người này không còn giờ trống ngày đó',
  tryOtherDayOrStaff: 'Bạn chọn ngày khác hoặc người khác ở trên nhé.',
  change: 'Đổi',
  callCustomer: 'Gọi khách',

  // Đặt lịch hộ
  bookingFor: 'Đặt cho ngày',
  customerSection: 'Khách',
  serviceSection: 'Dịch vụ',
  addService: 'Thêm dịch vụ',
  cancelAddService: 'Thôi, không thêm',
  removeService: (ten: string) => `Bỏ ${ten}`,
  servicesTotal: (n: number, thoiGian: string) => `${n}\u00A0dịch vụ · ${thoiGian}`,
  addServiceHint: 'Làm liền sau, cùng lần hẹn:',
  timeSection: 'Giờ còn trống',
  returning: 'Khách quen',
  // KH-GĐ2 4.3.3: gợi ý khách cũ khi gõ tên / số, chọn thì điền sẵn lần trước.
  suggestTitle: 'Khách cũ khớp',
  // Một dòng (ui-critic v29): "Khách quen · lần trước 22/09 · Sơn gel · Hạnh" — dịch vụ đã điền sẵn.
  returningLine: (ngay: string, dichVu: string, nguoi: string | null) =>
    `Khách quen · lần trước ${ngay} · ${dichVu}${nguoi === null ? '' : ` · ${nguoi}`}`,
  notThisCustomer: 'Không phải khách này',
  optional: 'không bắt buộc',
  nameExample: 'ví dụ: Chị Lan',
  tomorrowShort: 'Ngày mai',
  tryOtherDay: 'Bạn chọn ngày khác ở trên nhé.',
  pickTimeFirst: 'Chọn giờ để đặt',
  pickServiceFirst: 'Chọn dịch vụ ở trên để xem giờ còn trống.',
  pickServiceBtn: 'Chọn dịch vụ để đặt',
  forStaff: (ten: string) => `Giờ trống của ${ten}`,
  get staffPickTitle() {
    return chuHienTai().nhanVien
  },
  staffAny: 'Ai cũng được',
  tappedTimeTaken: (gio: string) =>
    `Lúc ${gio} không còn đủ chỗ cho dịch vụ này. Bạn chọn giờ khác nhé.`,
  jumpedDay: (tu: string, den: string, lyDo: string | null) => {
    const xem = den.toLowerCase() === 'ngày mai' ? 'ngày mai' : den
    if (lyDo === 'TOO_LATE') return `Hôm nay đã hết giờ nhận khách — đang xem ${xem}.`
    if (lyDo === 'CLOSED')
      return `Tiệm nghỉ ${tu === 'Hôm nay' ? 'hôm nay' : tu} — đang xem ngày mở cửa gần nhất: ${xem}.`
    return `${tu} đã kín — đang xem ngày gần nhất còn chỗ: ${xem}.`
  },
  bookingNow: 'Đang đặt…',
  bookAt: (gio: string, ngay: string) => `Đặt lịch lúc ${gio} · ${ngay}`,
  bookedToast: (ma: string) => `Đã đặt lịch · mã ${ma}`,

  // Chuẩn bị tiệm
  setupTitle: 'Chuẩn bị tiệm',
  // Kế hoạch 10/2026, 1.5: chỉ hứa "khách đặt được qua Zalo" khi ứng dụng đặt lịch trên Zalo đã chạy thật.
  setupHint: 'Làm xong các bước này là tiệm nhận lịch được.',
  setupHintLive: 'Làm xong các bước này là khách đặt được lịch qua Zalo.',
  setupProgress: (x: number, n: number) => `${x}/${n} bước`,
  // Kế hoạch 10/2026, 1.3: bốn bước đúng điều kiện nhận lịch thật (không chỉ "đã nhập").
  setupStep1: 'Giờ mở cửa',
  setupStep1Hint: 'Chưa có giờ mở cửa — bấm để đặt',
  setupStep1HintDone: 'Đã đặt — bấm để sửa',
  setupStep2: 'Dịch vụ và giá',
  setupStep2Hint: 'Tên, giá, thời gian làm',
  // KH-GĐ2 4.5: tiệm tự đăng ký có sẵn dịch vụ mẫu theo ngành. ADR-118 (26/10): có dịch vụ đang bán là XONG; giá còn là
  // giá mẫu chỉ là gợi ý nhẹ, không giữ thẻ lại.
  setupStep2HintGiaMau: 'Giá đang là giá mẫu — sửa khi cần',
  setupStep2HintSua: 'Bấm để xem hoặc sửa dịch vụ',
  setupStep3: 'Nhân viên làm dịch vụ',
  setupStep3Hint: 'Mỗi người cần có ca làm',
  setupStep3HintDone: 'Đã có nhân viên có ca — bấm để xem ca',
  setupStepQr: 'Mã QR cho khách',
  setupStepQrHint: 'Mở mã QR để in hoặc gửi cho khách',
  setupStepQrHintDone: 'Đã mở mã QR — bấm để in hoặc gửi cho khách',
  setupStepThu: 'Đặt thử một lịch',
  setupStepThuHint: 'Thử cho quen tay, huỷ được sau',
  setupStepThuHintDone: 'Đã có lịch đầu tiên',

  // Cấu hình — bổ sung
  hoursHint: 'Giờ nhận lịch của tiệm. Tiệm nghỉ trưa thì thêm khoảng thứ hai.',
  hoursAddRange: 'Thêm khoảng',
  hoursRemoveRange: 'Bỏ khoảng này',
  hoursOpenDay: 'Mở cửa',
  branchInfo: 'Thông tin chi nhánh',
  branchInfoHint: 'Khách thấy tên, địa chỉ và số điện thoại này khi đặt lịch.',
  serviceListTitle: 'Dịch vụ của tiệm',
  serviceListHint: 'Khách chỉ thấy dịch vụ đang bán và có người làm được.',
  serviceAddTitle: 'Thêm dịch vụ mới',
  staffListTitle: 'Nhân viên',
  staffListHint: 'Mỗi người đăng nhập bằng số điện thoại và mã riêng.',
  staffNew: 'Nhân viên mới',
  staffEditTitle: 'Hồ sơ nhân viên',
  staffDangerZone: 'Nghỉ việc',
  staffShiftWeek: 'Ca trong tuần',
  weekShort: ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'] as readonly string[],
  selected: 'Đã chọn',
  branchNameExample: 'ví dụ: Chi nhánh Quận 1',
  branchAddressExample: 'Số nhà, đường, phường, quận',
  get serviceNameExample() {
    return chuHienTai().viDuTenDichVu
  },
  priceWillShow: 'Khách sẽ thấy giá:',
  countItems: (n: number) => `${n}\u00A0dịch vụ`,
  serviceEmptyTitle: 'Chưa có dịch vụ nào',
  serviceOnSale: 'Đang bán',
  serviceOffSale: 'Ngừng bán',
  serviceEditTitle: 'Sửa dịch vụ',
  serviceSaveEdit: 'Lưu thay đổi',
  cancelEdit: 'Huỷ sửa',
  staffEmptyTitle: 'Chưa có nhân viên nào',
  get staffEmptyHint() {
    return chuHienTai().themNhanVienGoiY
  },
  doesServices: (n: number) => `${n}\u00A0dịch vụ`,

  // Bảng ca
  today: 'Hôm nay',
  prevDay: 'Hôm trước',
  nextDay: 'Hôm sau',
  branchLabel: 'Chi nhánh',
  // ADR-101: chi nhánh đang dùng chung cho cả web quầy (chỉ hiện khi tiệm có > 1 chi nhánh).
  cnNutAria: (ten: string) => `Đang dùng chi nhánh ${ten}. Bấm để đổi`,
  cnChonTieuDe: 'Chọn chi nhánh',
  cnDangDung: 'Đang dùng',
  noStaffToday: 'Hôm nay chưa xếp ca cho ai. Bạn xếp ca trước rồi mới đặt được lịch nhé.',
  closedToday: 'Hôm nay tiệm không mở cửa.',
  loading: 'Đang tải…',
  emptyDay: 'Hôm nay chưa có lịch nào.',

  // Trạng thái khách
  statusBooked: 'Đã đặt',
  statusCheckedIn: 'Khách đã tới',
  statusInService: 'Đang làm',
  statusDone: 'Đã xong',
  statusCancelled: 'Đã huỷ',
  statusNoShow: 'Không đến',
  statusDraft: 'Đang giữ chỗ',

  actionCheckIn: 'Khách đã tới',
  actionStart: 'Bắt đầu làm',
  actionDone: 'Xong',
  actionNoShow: 'Không đến',
  actionCancel: 'Huỷ lịch',
  // Câu hỏi lại đã giải thích chuyện bấm nhầm — nhãn ngắn để vừa nửa hàng trên điện thoại (ui-critic v24).
  actionNotArrived: 'Chưa tới',
  // K4 (v0.22.2, Q1): hai lối ra khỏi "Đang làm" — lùi (bấm nhầm "Bắt đầu làm") và đóng lịch khi khách bỏ về.
  actionNotStarted: 'Chưa bắt đầu',
  actionLeftMidway: 'Khách về giữa chừng',
  // K10 (v0.22.2): giữ chỗ của khách tự đặt trên Zalo — quầy không chốt hộ.
  draftMiniApp: 'Khách đang giữ chỗ trên Zalo, tự bỏ giữ chỗ sau 7 phút nếu khách không chốt.',

  // Đặt lịch hộ khách
  newBooking: 'Đặt lịch cho khách',
  phoneLabel: 'Số điện thoại khách',
  phonePlaceholder: '09xx xxx xxx',
  phoneInvalid: 'Số điện thoại chưa đúng. Bạn kiểm tra lại giúp nhé.',
  nameLabel: 'Tên khách',
  namePlaceholder: 'Khách mới',
  serviceLabel: 'Dịch vụ',
  pickTime: 'Chọn giờ',
  morning: 'Sáng',
  afternoon: 'Chiều',
  evening: 'Tối',
  slotTakenHint: 'Khe giờ vừa có người đặt. Bạn đọc giúp khách một trong các giờ này nhé:',
  bookFailed: 'Không đặt được lịch. Bạn thử lại giúp nhé.',
  noTenant: 'Chưa chọn được tiệm. Bạn liên hệ người cài đặt giúp nhé.',
  boardFailed: 'Không tải được bảng ca.',
  statusFailed: 'Không đổi được trạng thái.',
  serverFailed: 'Không nối được máy chủ.',
  noSlot: 'Hôm nay không còn giờ trống cho dịch vụ này.',
  bookClosedDay: 'Tiệm nghỉ ngày này',
  confirm: 'Đặt lịch',
  cancel: 'Đóng',
  booked: 'Đã đặt xong',
  bookedCode: 'Mã lịch',

  // Đăng nhập
  loginTitle: 'Đăng nhập',
  loginHint:
    'Chủ tiệm, lễ tân và nhân viên đều vào ở đây — mỗi người một mã riêng, vào xong chỉ thấy phần việc của mình.',
  loginWelcomeName: (ten: string) => `Chào ${ten}`,
  loginPinOnly: 'Nhập mã đăng nhập để vào làm việc.',
  notMe: 'Không phải bạn?',
  loginPhoneLabel: 'Số điện thoại của bạn',
  pinLabel: 'Mã đăng nhập',
  pinPlaceholder: '6 số',
  loginButton: 'Vào làm việc',
  loggingIn: 'Đang vào…',
  logout: 'Đăng xuất',
  installApp: 'Cài lên màn hình chính',
  installHint: 'Mở bằng một chạm như ứng dụng, không cần gõ địa chỉ.',
  installIos: 'Trên iPhone, iPad: bấm nút Chia sẻ rồi chọn "Thêm vào Màn hình chính".',
  sessionEnded: 'Phiên làm việc đã kết thúc. Bạn đăng nhập lại nhé.',

  // Đổi mã
  changePinTitle: 'Đổi mã đăng nhập',
  changePinWhy: 'Mã hiện tại do chủ tiệm đặt. Bạn đổi sang mã riêng của mình rồi mới làm việc nhé.',
  oldPinLabel: 'Mã hiện tại',
  newPinLabel: 'Mã mới',
  newPinAgainLabel: 'Nhập lại mã mới',
  pinMismatch: 'Hai lần nhập mã chưa giống nhau.',
  changePinButton: 'Đổi mã',
  changePinDone: 'Đã đổi mã. Bạn nhớ mã mới nhé.',

  // Cấu hình tiệm
  configTitle: 'Cấu hình tiệm',
  configOpen: 'Cấu hình',
  configBack: 'Về bảng ca',
  tabBranch: 'Chi nhánh',
  tabService: 'Dịch vụ',
  tabStaff: 'Nhân viên',
  tabQr: 'Mã QR đặt lịch',
  tabSettings: 'Cài đặt tiệm',
  // RETRO bảo mật 7: hai quyền của thợ tách riêng.
  setStaffTitle: 'Quyền của nhân viên',
  setStaffHint: 'Thợ chỉ thấy khách của chính mình. Lưu ngay khi bạn bấm.',
  setManagerRevenue: 'Quản lý xem doanh thu và báo cáo',
  setDiscountMax: 'Giảm giá tối đa khi thu tiền',
  setDiscountHint: 'Quá mức này thì quầy không giảm được — tránh giảm tay quá tay.',
  // KH-GĐ2 6.2.4: mã duyệt giảm giá (khác mã đăng nhập)
  setApproveNew: 'Mã duyệt giảm giá (6 đến 12 số)',
  setApproveChange: 'Đổi mã duyệt giảm giá',
  setApproveHint:
    'Khi quầy cần giảm quá mức trên, bạn gõ mã này ngay tại quầy. Đặt KHÁC mã đăng nhập của bạn.',
  setApproveHas: 'Đã có mã duyệt. Quầy giảm quá mức thì bạn gõ mã này để cho phép.',
  setApproveSaved: 'Đã lưu mã duyệt giảm giá.',
  setApproveSave: 'Lưu mã',
  setDiscountPct: (bp: number) => (bp === 0 ? 'Không giảm' : `${bp / 100}%`),
  setStaffPhone: 'Thợ thấy đủ số điện thoại khách (tắt: chỉ thấy 0901***296)',
  setStaffPhotos: 'Thợ xem và chụp ảnh buổi làm của khách mình làm',
  setStaffCheckout: 'Thợ tự nhận khách vào và tính tiền khách mình làm',
  setStaffCheckoutHint: 'Thợ vẫn không thấy doanh thu, két, sổ chi và không huỷ được hoá đơn.',
  setBookingTitle: 'Đặt lịch qua Zalo',
  setBookingHint: 'Khách quét mã QR của tiệm là đặt được giờ trống. Lưu ngay khi bạn bấm.',
  setSelfBooking: 'Cho khách tự đặt lịch trên Zalo',
  setManualApprove: 'Tiệm duyệt từng lịch khách đặt (giờ vẫn được giữ trong lúc chờ duyệt)',
  setRemindWhen: 'Nhắc khách lúc',
  setRemind24h: 'Trước 24 giờ',
  setRemindMorning: 'Sáng cùng ngày',
  setConfirmDeadline: 'Báo tôi khi khách chưa bấm “vẫn đến”, trước giờ hẹn',
  setHoursBefore: (gio: number) => `${gio}\u00A0giờ trước`,
  qrTitle: 'Mã QR đặt lịch của tiệm',
  qrHint:
    'Khách quét bằng Zalo là mở thẳng trang đặt lịch của tiệm. In ra dán ở quầy, gương, cửa kính.',
  qrChoBranch: 'Mã cho chi nhánh',
  qrWholeShop: 'Cả tiệm',
  qrBranchTip: 'Mỗi chi nhánh dán mã của chính nó: khách quét là vào đúng nơi, khỏi phải chọn lại.',
  qrPosterLead: 'Quét mã bằng Zalo để đặt lịch',
  qrStep1: 'Mở Zalo, bấm biểu tượng quét mã',
  qrStep2: 'Chọn dịch vụ và giờ bạn muốn',
  qrStep3: 'Bấm “Xác nhận đặt lịch” — xong',
  // B8 (10/10/2026): không hứa tin nhắc tự động (chưa bật; tiệm chọn "sáng cùng ngày" cũng không phải 24 giờ).
  // Kế hoạch 10/2026, 1.5: câu luôn đúng khi đã chạy thật trên Zalo (xem lại / đổi giờ / huỷ nằm trong "Của tôi").
  qrPosterFoot: 'Đổi giờ hoặc huỷ lịch ngay trong Zalo',
  qrPrint: 'In tờ dán quầy',
  qrDownload: 'Tải ảnh mã QR',
  qrCopy: 'Sao chép đường dẫn',
  qrShare: 'Chia sẻ mã QR',
  qrShareText: (tenTiem: string, link: string) =>
    `Đặt lịch ${tenTiem} qua Zalo — bấm vào đây hoặc quét mã: ${link}`,
  qrShareFailed: 'Máy chưa chia sẻ được. Bạn tải ảnh mã QR rồi gửi qua Zalo nhé.',
  qrCopied: 'Đã chép đường dẫn — dán vào Zalo hoặc Facebook để gửi khách.',
  qrCopyFailed: 'Máy chưa cho chép. Bạn bấm giữ vào đường dẫn để chép nhé.',
  qrCodeLabel: (ma: string) => `Mã đặt lịch: ${ma}`,
  qrRotate: 'Đổi mã QR',
  qrRotateTitle: 'Đổi sang mã QR mới?',
  qrRotateWarn:
    'Mã cũ ngừng chạy ngay lúc này. Tờ QR đã in, ảnh đã gửi khách đều phải thay bằng mã mới. Chỉ đổi khi QR bị dán sai chỗ hoặc bị người lạ dùng.',
  qrRotateOk: 'Đổi mã',
  qrRotateDone: 'Đã đổi mã. Bạn in lại tờ dán quầy nhé.',
  // Kế hoạch 10/2026, 1.5: ứng dụng đặt lịch trên Zalo CHƯA chạy thật → không có tờ in / nút gửi khách / mã QR / đường dẫn, chỉ khung này.
  qrChuaLive:
    'Mã QR sẽ dùng được khi Zalo duyệt ứng dụng đặt lịch. Trong lúc chờ, bạn đặt lịch cho khách ngay ở quầy.',
  qrChuaLiveNut: 'Đặt lịch ở quầy',

  branchName: 'Tên chi nhánh',
  branchAddress: 'Địa chỉ',
  branchPhone: 'Số điện thoại tiệm',
  branchCutoff: 'Khách được huỷ trước (phút)',
  branchAdd: 'Thêm chi nhánh',
  branchSave: 'Lưu chi nhánh',
  hoursTitle: 'Giờ mở cửa',
  hoursOpen: 'Mở',
  hoursClose: 'Đóng',
  hoursClosedDay: 'Nghỉ',
  hoursCopyAll: 'Chép cho cả tuần',
  hoursSave: 'Lưu giờ mở cửa',
  hoursSaved: 'Đã lưu giờ mở cửa.',

  serviceNameLabel: 'Tên dịch vụ',
  servicePrice: 'Giá (đồng)',
  serviceMinutes: 'Thời\u00A0gian',
  serviceReturn: 'Nhắc khách quay lại',
  serviceReturnDefault: (n: number) => `Mặc định (${n} ngày)`,
  serviceReturnDays: (n: number) => `Sau ${n} ngày`,
  serviceAdd: 'Thêm dịch vụ',
  serviceSave: 'Lưu',
  serviceStop: 'Ngừng dùng',
  serviceResume: 'Dùng lại',
  serviceStopped: 'Đang ngừng',
  serviceEmpty: 'Chưa có dịch vụ nào. Bạn thêm dịch vụ đầu tiên nhé.',

  staffNameLabel: 'Tên nhân viên',
  staffPhone: 'Số điện thoại',
  staffRole: 'Vai',
  staffBranches: 'Làm ở chi nhánh',
  staffServices: 'Làm được dịch vụ',
  staffAdd: 'Thêm nhân viên',
  edit: 'Sửa',
  staffSave: 'Lưu nhân viên',
  // Nút Lưu ẩn cho tới khi đủ thông tin — nói rõ còn thiếu gì.
  staffMissingPrefix: 'Còn thiếu:',
  staffMissingName: 'tên',
  staffMissingPhone: 'số điện thoại đúng',
  staffMissingBranch: 'chi nhánh',
  // Kế hoạch 10/2026, 1.4b: tiệm chưa có chi nhánh thì chưa xếp ca được — nói rõ và dẫn sang tạo chi nhánh.
  staffNoBranch: 'Tiệm chưa có chi nhánh nên chưa xếp ca được. Tạo chi nhánh trước nhé.',
  staffNoBranchGo: 'Tạo chi nhánh',
  // Sau khi lưu chi nhánh đầu tiên (đến từ tờ "Thêm nhân viên"): quay lại đúng chỗ đang gõ dở.
  branchSavedBack: 'Đã lưu chi nhánh. Bây giờ bạn thêm nhân viên được rồi.',
  staffBackToAdd: 'Quay lại thêm nhân viên',
  staffMissingService: 'ít nhất một dịch vụ',
  staffMissingRoleSwitch: 'bật phân quyền cho vai này',
  roleNeedSwitch: 'Vai này cần bật "Phân quyền chi tiết" của tiệm.',
  roleNeedSwitchBtn: 'Bật phân quyền chi tiết',
  staffStop: 'Cho nghỉ',
  staffResume: 'Đi làm lại',
  staffStopped: 'Đã nghỉ',
  staffSetPin: 'Đặt mã đăng nhập',
  staffLogoutAll: 'Đăng xuất mọi máy của người này',
  staffLogoutDone: (n: number) =>
    n === 0 ? 'Người này không đăng nhập ở máy nào.' : `Đã đăng xuất ${n} máy.`,
  // v0.22.3 (Q3, Q4): tờ nhân viên của CHÍNH MÌNH — đổi mã cần mã đang dùng, đăng xuất giữ máy đang dùng, vai khoá, đổi số phải gõ mã.
  staffRoleSelfNote: 'Bạn không đổi được vai của chính mình.',
  staffChangeMyPin: 'Đổi mã của tôi',
  staffChangeMyPinDone: 'Đã đổi mã. Các máy khác sẽ phải đăng nhập lại.',
  staffLogoutOthers: 'Đăng xuất các máy khác',
  staffLogoutOthersDone: (n: number) =>
    n === 0 ? 'Bạn không đăng nhập ở máy nào khác.' : `Đã đăng xuất ${n} máy khác.`,
  staffPhoneNeedPin: 'Đổi số đăng nhập của bạn. Nhập mã của bạn để xác nhận.',
  staffPhonePinLabel: 'Mã đăng nhập của bạn',
  staffPhoneSelfDone: (so: string) => `Từ lần sau bạn đăng nhập bằng số ${so}.`,
  staffMissingPin: 'mã đăng nhập để đổi số',
  // v0.23.1 (ADR-123; B-N1): việc chạm tới một CHỦ TIỆM cần mã đăng nhập CỦA NGƯỜI ĐANG LÀM. Hộp "Nhập mã của bạn" dùng CÂU của máy chủ
  // (đúng việc đang làm); ô mã trong tờ nhân viên (khi Lưu) thêm dòng gợi ý này khi ô hiện vì vai / chủ khác.
  pinConfirmTitle: 'Nhập mã của bạn',
  pinConfirmOk: 'Xác nhận',
  pinConfirmCancel: 'Thôi',
  /** Vòng sửa 1 (G-N1): hộp giữ mở trong lúc máy chủ kiểm mã; nút Xác nhận đổi chữ và khoá. */
  pinChecking: 'Đang kiểm…',
  staffOwnerPinHint: 'Việc này đổi quyền Chủ tiệm. Nhập mã của bạn để xác nhận.',
  /** G-L1: chỉ đổi SỐ đăng nhập của một chủ khác (vai không đổi) — không nói "đổi quyền". */
  staffOtherPhonePinHint: 'Đổi số đăng nhập của chủ tiệm khác. Nhập mã của bạn để xác nhận.',
  staffMissingPinOwner: 'mã đăng nhập của bạn để xác nhận',
  staffPinSection: 'Mã đăng nhập',
  staffPinIs: 'Mã đăng nhập mới của',
  staffPinNote: `Bạn đọc mã này cho nhân viên. Họ quét mã QR bên dưới hoặc vào ${TEN_MIEN_SAPA}, gõ số điện thoại và mã này, rồi đổi sang mã riêng.`,
  staffQrMo: 'Hiện mã QR',
  staffQrAn: 'Ẩn mã QR',
  staffQrGoiY:
    'Nhân viên quét mã để mở trang đăng nhập SAPA, rồi gõ số điện thoại và mã đăng nhập. Mã QR không chứa mã đăng nhập.',
  staffNoPin: 'Chưa có mã đăng nhập',
  staffMustChange: 'Cần đổi mã',
  // Phản ánh 25/09: vai nói rõ làm được gì; ai cũng có thể nhận khách; Quản lý chỉ xếp ca / cho nghỉ.
  roleHint: {
    technician: 'Làm dịch vụ. Chỉ thấy lịch và khách của mình, bấm khách đã tới → xong.',
    cashier: 'Đặt lịch, đón khách, thu tiền. Không sửa cấu hình, không hoàn tiền.',
    manager: 'Như lễ tân, thêm: sửa dịch vụ và giá, xếp ca, hoàn tiền.',
    owner: 'Toàn quyền: nhân viên, mã đăng nhập, hoa hồng, cài đặt tiệm.',
  } as Record<string, string>,
  roleTableOpen: 'Ai làm được gì?',
  configGroupShop: 'Tiệm',
  configGroupOwner: 'Chỉ chủ tiệm',
  roleTableClose: 'Ẩn bảng',
  roleTableTitle: 'Mỗi vai làm được gì',
  roleTableOwn: 'của mình',
  roleTableNote: 'Bảng này theo cài đặt hiện tại của tiệm (mục "Quyền của nhân viên").',
  roleJobs: [
    ['xem.bang-ca', 'Xem lịch hẹn'],
    ['doi-trang-thai', 'Bấm khách đã tới / đang làm / xong'],
    ['dat-lich', 'Đặt, đổi giờ, huỷ lịch cho khách'],
    ['khach-vao', 'Nhận khách vào (không hẹn trước)'],
    ['tim-khach', 'Tìm khách, xem lịch sử khách'],
    ['xem.sdt-khach', 'Thấy số điện thoại khách'],
    ['xem.anh-khach', 'Xem, chụp ảnh buổi làm'],
    ['thu-tien.lich', 'Tính tiền lịch hẹn'],
    ['thu-tien', 'Két, bán gói, nạp ví, danh sách hoá đơn'],
    ['hoan-dao-tien', 'Hoàn tiền, huỷ hoá đơn'],
    ['xem.doanh-thu', 'Xem doanh thu, báo cáo'],
    ['cau-hinh.tiem', 'Sửa dịch vụ, giá, chi nhánh, mã QR'],
    ['xep-ca', 'Xếp ca, cho nghỉ'],
    ['cau-hinh.nhan-vien', 'Thêm người, đổi vai, đặt mã, cài đặt tiệm'],
    ['xem.goi-sapa', 'Xem gói SAPA, tiền tin Zalo'],
  ] as const,
  staffServesCustomers: 'Người này nhận khách',
  staffServesHint: 'Bật khi người này cũng làm dịch vụ — khách đặt được lịch với họ.',
  staffShiftOnlyNote: 'Bạn xếp ca và ngày nghỉ. Thêm người, đổi vai, đặt mã là việc của chủ tiệm.',
  staffShiftSave: 'Lưu ca làm',

  shiftTitle: 'Ca làm việc hằng tuần',
  offTitle: 'Ngày nghỉ',
  offFrom: 'Nghỉ từ ngày',
  offTo: 'Đến ngày',
  offToHint: 'Bỏ trống nếu chỉ nghỉ một ngày.',
  offReason: 'Lý do (không bắt buộc)',
  offReasonExample: 'Ví dụ: về quê',
  offAdd: 'Thêm ngày nghỉ',
  offCancel: 'Huỷ ngày nghỉ này',
  // STT 3.4 (ADR-092): nghỉ đột xuất + chuyển lịch. cho nghỉ luôn lưu nên thay `offBusy` cũ bằng `offSavedBusy`.
  offSavedBusy:
    'Đã lưu ngày nghỉ. Người này còn các lịch sau — mở màn Lịch ngày đó để chuyển người:',
  offStillBusy: (n: number) => `còn ${n} lịch cần chuyển`,
  // BK-2 (ADR-096): đổi ca / cho nghỉ việc / đổi giờ mở cửa vẫn LƯU, rồi liệt kê lịch không còn người làm.
  shiftSavedBusy: 'Đã lưu ca. Các lịch sau nằm ngoài ca mới — bấm vào lịch để chuyển người:',
  stopSavedBusy: 'Đã cho nghỉ việc. Người này còn các lịch sau — bấm vào lịch để chuyển người:',
  hoursSavedBusy:
    'Đã lưu giờ mở cửa. Các lịch sau nằm ngoài giờ mở cửa mới — bấm vào lịch để gọi khách đổi giờ:',
  busyMore: (n: number) => `và ${n} lịch nữa`,
  // K2 (ADR-111): đóng cửa cả chi nhánh theo ngày — lưu rồi liệt kê lịch khách đã đặt vào những ngày đó.
  closeDaysTitle: 'Ngày tiệm nghỉ',
  closeDaysHint: 'Nghỉ Tết, nghỉ lễ, sửa tiệm, mất điện… Những ngày này khách không đặt được lịch.',
  closeReasonExample: 'Ví dụ: Nghỉ Tết',
  closeDo: 'Đóng cửa những ngày này',
  closeDoing: 'Đang lưu…',
  closeSaved: 'Đã đóng cửa những\u00A0ngày\u00A0này',
  closeSavedBusy:
    'Đã đóng cửa. Khách đã đặt lịch vào những\u00A0ngày\u00A0này — bấm vào từng lịch để gọi khách đổi ngày:',
  closeStillBusy: (n: number) => `còn ${n} lịch cần gọi khách`,
  closeReopen: 'Mở lại những\u00A0ngày\u00A0này',
  closeReopenShort: 'Mở lại',
  closeReopened: 'Đã mở lại những ngày này',
  closeNone: 'Chưa có ngày nghỉ nào sắp tới.',
  closedHintDong: 'Tiệm đã đóng cửa ngày\u00A0này. Muốn mở lại, vào Cấu hình → Chi nhánh.',
  closedBandReason: (lyDo: string | null) =>
    lyDo === null ? 'Tiệm nghỉ ngày này' : `Tiệm nghỉ ngày này · ${lyDo}`,
  offBandClosed: (n: number) =>
    `Tiệm nghỉ ngày\u00A0này\u00A0— còn ${n} lịch cần gọi khách đổi ngày`,
  offTagClosed: 'Tiệm nghỉ',
  offBandOutside: (n: number) => `${n} lịch không có người làm — cần xử lý`,
  offBandAll: (n: number) => `Còn ${n} lịch cần xử lý`,
  offTagOutside: 'Ngoài ca',
  offTagStopped: 'Đã nghỉ việc',
  offTodayButton: 'Nghỉ đột xuất',
  // Chữ ngắn của nút trên điện thoại hẹp (ba nút chung một hàng ở 320–479px).
  offTodayShort: 'Báo nghỉ',
  offTodayTitle: 'Ai nghỉ hôm nay?',
  offTodayPickHint: 'Chọn người báo nghỉ. Khách sẽ không đặt được giờ của người đó hôm nay.',
  offTodayConfirm: (ten: string) => `Cho ${ten} nghỉ hết hôm nay?`,
  offTodayConfirmHint: 'Lịch đã có của người này sẽ hiện ra để bạn chuyển cho người khác.',
  offTodaySave: 'Cho nghỉ',
  offTodaySaving: 'Đang lưu…',
  offTodayPickOther: 'Chọn người khác',
  offTodayNobody: 'Hôm nay không còn ai có ca để cho nghỉ.',
  // v0.22.3 B1 (ADR-122): người nhận khách CUỐI CÙNG nghỉ = cả tiệm nghỉ → mời "Đóng cửa tiệm hôm nay" (K2) thay vì cho nghỉ một người.
  offShopTitle: 'Cả tiệm nghỉ hôm nay?',
  offShopHint: (ten: string) =>
    `Hôm nay chỉ có ${ten} nhận khách. Đóng cửa tiệm hôm nay thì khách không đặt được giờ hôm nay. Lịch đã có sẽ hiện ra để bạn gọi khách đổi ngày.`,
  offShopSave: 'Đóng cửa tiệm hôm nay',
  offShopSaving: 'Đang đóng cửa…',
  offShopKeep: 'Thôi',
  // G-N3: tiêu đề tờ danh sách ngay sau khi bấm "Đóng cửa tiệm hôm nay".
  offShopClosedTitle: 'Đã đóng cửa tiệm hôm nay',
  offShopReopen: 'Mở cửa lại hôm nay',
  offShopReopenDone: 'Tiệm mở cửa lại hôm nay.',
  offShopNoRight: 'Bạn nhờ chủ tiệm đóng cửa tiệm giúp nhé.',
  // L-N1: máy chủ báo hết người nhận khách ở chi nhánh KHÁC chi nhánh đang xem — không đóng nhầm, chỉ chỉ đường.
  offShopOtherBranch: (ten: string, chiNhanh: string) =>
    `Hôm nay chỉ còn ${ten} nhận khách ở ${chiNhanh}. Bạn đổi sang chi nhánh đó (ở đầu màn) rồi đóng cửa tiệm hôm nay nhé.`,
  offShopOtherBranchName: 'chi nhánh khác',
  // v0.22.3 B5 (Q2): hỏi lại một lần khi lưu xong tiệm sẽ không nhận được khách. Nút chính là "Thôi, để như cũ" (an toàn), "Vẫn lưu" là phụ.
  stopTitle: 'Tiệm sẽ không nhận được khách',
  stopNoStaff: 'Lưu xong, tiệm không còn ai nhận khách. Khách sẽ không đặt được lịch.',
  stopNoService: 'Đây là dịch vụ cuối cùng đang bán. Tắt đi thì khách không đặt được lịch.',
  stopNoHours:
    'Chi nhánh sẽ không mở cửa ngày nào. Khách không đặt được lịch. Nghỉ vài ngày thì bạn dùng "Ngày tiệm nghỉ" nhé.',
  stopKeep: 'Thôi, để như cũ',
  stopSaveAnyway: 'Vẫn lưu',
  // Tờ nhân viên → mục Ngày nghỉ: máy chủ từ chối vì người này là người nhận khách cuối; lối sang "Ngày tiệm nghỉ" (Cấu hình → Chi nhánh).
  offDaysGoClose: 'Mở Ngày tiệm nghỉ',
  offBandOne: (ten: string, n: number) => `${ten} nghỉ hôm nay — còn ${n} lịch cần xử lý`,
  offBandOneDay: (ten: string, ngay: string, n: number) =>
    `${ten} nghỉ ngày ${ngay} — còn ${n} lịch cần xử lý`,
  offBandMany: (soNguoi: number, n: number) => `${soNguoi} người nghỉ — còn ${n} lịch cần xử lý`,
  offBandAction: 'Xử lý',
  // K9 (v0.22.2): lịch ngày trước khách đã tới mà quầy chưa đóng / chưa thu tiền — chỉ nhắc, không tự đổi gì.
  chuaDongTruoc: (n: number) => `Còn ${n} lịch hôm trước chưa thu tiền`,
  xemLichChuaDong: 'Xem lịch cũ nhất',
  offListTitle: (n: number) => `Còn ${n} lịch cần xử lý`,
  offRowOf: (ten: string) => `Lịch của ${ten}`,
  offMoveTo: (ten: string) => `Chuyển sang ${ten}`,
  offOthersFree: 'Người khác cũng rảnh giờ này:',
  offNoOneFree: 'Không ai rảnh giờ này',
  offClosedCallDay: 'Tiệm nghỉ ngày này\u00A0— gọi khách đổi ngày',
  offCallReschedule: 'Gọi khách đổi giờ',
  offCallPhone: (sdt: string) => `Gọi ${sdt}`,
  // B7: lịch chờ nhận / chờ cọc còn ở tương lai thì chuyển người được như lịch đã nhận; câu dưới chỉ cho lịch chờ mà ĐÃ tới / qua giờ hẹn.
  offPending: 'Lịch này chưa được nhận mà đã tới giờ hẹn. Mở lịch, bấm Từ chối hoặc Huỷ lịch.',
  offTagPending: 'Chờ nhận',
  offTagDeposit: 'Chờ cọc',
  offMulti: 'Lịch có nhiều dịch vụ. Mở lịch, huỷ rồi đặt lại cho người khác.',
  offOpen: 'Mở lịch',
  offMoving: 'Đang chuyển…',
  offMoved: (khach: string, ten: string) => `Đã chuyển ${khach} sang ${ten}`,
  offAllDone: (ten: string) => `Đã xử lý hết lịch của ${ten}.`,
  offNothing: 'Không có lịch nào cần chuyển.',
  offDone: 'Xong',
  offLoadFailed: 'Chưa tải được danh sách lịch. Bấm Tải lại.',
  // `coTheDoi`: người này đổi được chi nhánh (> 1 chi nhánh chọn được). Lễ tân / KTV chỉ được giao một chi nhánh thì không tự đổi được.
  offOtherBranch: (n: number, coTheDoi: boolean) =>
    coTheDoi
      ? `Còn ${n} lịch ở chi nhánh khác. Đổi chi nhánh ở đầu màn để xử lý.`
      : `Còn ${n} lịch ở chi nhánh khác. Nhờ chủ tiệm hoặc người phụ trách chi nhánh đó xử lý.`,
  offUndo: 'Huỷ nghỉ',
  offUndoConfirm: (ten: string) => `Cho ${ten} đi làm lại hôm nay?`,
  offUndoSave: 'Đi làm lại',
  offUndoKeep: 'Không, vẫn nghỉ',
  offColumnToday: 'Nghỉ hôm nay',
  offColumn: 'Nghỉ',
  walkInName: 'Khách lẻ',
  // N2: tiền cọc (tiền vào thẳng tài khoản tiệm; quầy chỉ xác nhận).
  depositTitle: 'Tiền cọc',
  depositWaiting: 'Khách đang chuyển cọc. Thấy tiền trong tài khoản thì bấm “Ghi nhận tiền cọc”.',
  depositHolding: (tien: string) => `Đang giữ cọc ${tien}`,
  depositAutoApply: 'tự trừ vào hoá đơn khi thu tiền',
  depositAmount: 'Số tiền đã nhận',
  depositReceive: 'Đã nhận cọc',
  depositReceiveCta: 'Ghi nhận tiền cọc',
  depositNone: 'Chưa nhận cọc',
  depositCancelledHint: 'Lịch đã huỷ. Khách đã chuyển cọc thì ghi sổ, rồi bấm Hoàn\u00A0cọc.',
  depositReceived: (tien: string) => `Đã ghi nhận cọc ${tien}.`,
  depositRefund: 'Hoàn cọc',
  depositRefundReasonHint: 'Ví dụ: khách báo bận, tiệm huỷ lịch',
  depositRefundConfirm: (tien: string) => `Đã trả lại khách ${tien}`,
  depositRefunded: (tien: string) => `Đã ghi hoàn cọc ${tien}.`,
  depositKeep: 'Giữ cọc (khách không đến)',
  depositKept: (so: string, tien: string) => `Đã giữ cọc ${tien} — hoá đơn ${so}.`,
  depositByTransfer: 'Chuyển khoản',
  depositByCash: 'Tiền mặt',
  depositHeldChip: 'Đang giữ cọc',
  depositReverse: 'Sửa cọc ghi nhầm',
  depositReverseHint: 'Ví dụ: gõ nhầm số tiền',
  depositReverseConfirm: (tien: string) => `Xoá lần ghi nhận cọc ${tien}`,
  depositReversed: (tien: string) =>
    `Đã sửa: bỏ lần ghi nhận cọc ${tien}. Bạn ghi nhận lại số đúng.`,
  depositKeepReasonHint: 'Ví dụ: khách không đến, không báo trước',
  depositKeepConfirm: (tien: string) => `Giữ cọc ${tien}`,
  depositSetPin: 'Mã đăng nhập của bạn',
  // v0.23.2: tài khoản nhận tiền có thẻ RIÊNG (khai không cần bật cọc); khai lần đầu hoặc đổi đều phải nhập lại mã.
  accountTitle: 'Tài khoản nhận tiền',
  accountHint:
    'Khách quét mã QR để chuyển tiền vào tài khoản này khi trả tiền ở quầy và khi đặt cọc. Tiền vào thẳng tài khoản của tiệm.',
  accountChange: 'Đổi tài khoản',
  accountSave: 'Lưu tài khoản',
  accountCancel: 'Thôi',
  accountPinHint: 'Khai hoặc đổi tài khoản nhận tiền cần nhập lại mã để chắc chắn là bạn.',
  // Vòng sửa 1 (B1): hai thẻ có hai nút Lưu riêng — chữ nút, câu xác nhận và câu nhắc nói đúng THẺ nào vừa lưu / chưa lưu.
  accountSaved: 'Đã lưu tài khoản nhận tiền.',
  accountUnsaved: 'Bạn chưa bấm “Lưu tài khoản”.',
  depositSave: 'Lưu cọc',
  depositSaved: 'Đã lưu cài đặt cọc.',
  depositNeedAccount:
    'Muốn bật cọc, bạn khai tài khoản nhận tiền ở thẻ “Tài khoản nhận tiền” phía trên trước nhé.',
  depositSetTitle: 'Đặt cọc giữ chỗ',
  depositSetHint:
    'Khách chuyển cọc thẳng vào tài khoản của tiệm, tới làm thì cọc tự trừ vào hoá đơn. Sửa xong bấm “Lưu cọc” ở cuối thẻ.',
  depositSetOn: 'Bắt khách đặt cọc',
  depositSetWho: 'Ai phải đặt cọc?',
  depositSetWhoLabel: (a: 'khach_moi' | 'khach_hay_vang' | 'moi_lich') =>
    a === 'khach_moi' ? 'Khách mới' : a === 'khach_hay_vang' ? 'Hay bỏ hẹn' : 'Mọi lịch',
  depositSetAmount: 'Số tiền cọc',
  depositSetHold: 'Giữ chỗ chờ khách chuyển tiền',
  depositSetMinutes: (p: number) => (p >= 60 ? `${p / 60} giờ` : `${p} phút`),
  depositSetBank: 'Ngân hàng nhận tiền',
  depositSetBankPick: 'Chọn ngân hàng',
  depositSetAccountNo: 'Số tài khoản',
  depositSetAccountName: 'Tên chủ tài khoản',
  depositSetPolicy: 'Lời dặn khách về tiền cọc',
  depositSetPolicyHint: 'Ví dụ: Huỷ trước 1 ngày được hoàn cọc',
  // N4: khách vãng lai + xoay vòng kỹ thuật viên.
  walkInTitle: 'Khách vào',
  get walkInHint() {
    return chuHienTai().khachVangLaiGoiY
  },
  walkInService: 'Khách làm dịch vụ gì?',
  walkInChangeService: 'Đổi',
  walkInNobody: 'Lúc này không ai rảnh làm dịch vụ này. Bạn đặt lịch cho khách giờ sau nhé.',
  walkInStaff: (gio: string) => `Người làm (bắt đầu ${gio})`,
  walkInTurns: (n: number) => (n === 0 ? 'chưa có khách' : `${n} lượt`),
  walkInSuggested: 'Tới lượt',
  walkInOverride: 'Bạn chọn khác người tới lượt — tiệm vẫn ghi lại để chia khách công bằng.',
  // RETRO bảo mật 10: số trùng hồ sơ có sẵn — nói rõ trước khi bấm Bắt đầu.
  walkInMatched: 'Số này là của khách cũ. Không đúng người thì sửa lại số.',
  walkInAddCustomer: '+ Thêm tên, số khách (không bắt buộc)',
  walkInPhone: 'Số điện thoại khách',
  walkInName2: 'Tên khách',
  walkInStart: 'Bắt đầu',
  walkInDone: (ten: string) => (ten === '' ? 'Đã xếp khách vào.' : `Đã xếp khách cho ${ten}.`),
  saving: 'Đang lưu…',
  shiftWorks: 'Đi làm',
  shiftFrom: 'Vào ca',
  shiftTo: 'Tan ca',
  shiftSave: 'Lưu ca làm việc',
  shiftSaved: 'Đã xếp ca cho 60 ngày tới.',
  shiftNoBranch: 'Bạn chọn chi nhánh cho nhân viên này trước nhé.',

  saved: 'Đã lưu.',
  savingText: 'Đang lưu…',

  // Chung
  retry: 'Thử lại',
  minutes: 'phút',
  walkIn: 'Khách tới trực tiếp',
  noShowWarning: 'Khách này đã bỏ hẹn nhiều lần',
  savedLastVisit: 'Lần gần nhất',
  never: 'Chưa từng tới',
  screenBroken: 'Màn hình này đang bị lỗi.',
  screenBrokenHint: 'Bạn bấm Tải lại để mở lại. Dữ liệu của tiệm không bị mất.',
  reload: 'Tải lại',
  backToStart: 'Về màn đầu',
  // Đợt 3 · 3.1: bảng lịch khi mạng chập chờn.
  matMangDangThu: 'Không có mạng · đang thử lại…',
  // Mở app mà chưa tới được máy chủ: phiên vẫn còn, chỉ cần thử lại (không đẩy ra màn đăng nhập).
  khongToiDuocMayChu: 'Chưa kết nối được. Bạn kiểm tra mạng rồi bấm Thử lại nhé.',
  thuLai: 'Thử lại',
  capNhatLuc: (gio: string) => `Cập nhật lúc ${gio}`,
  chuaChacDaLuu: 'Mạng chậm, chưa chắc đã lưu. Bạn bấm lại nút vừa bấm để thử — đừng mở tờ mới.',
  lichDaDoiMayKhac: 'Lịch này vừa được đổi ở máy khác. Bạn đóng tờ này rồi xem lại lịch nhé.',
  // Đợt 3 · 3.2: gọi / nhắn SAPA ở mọi lúc.
  goiSapa: 'Gọi SAPA',
  nhanZaloSapa: 'Nhắn Zalo cho SAPA',
  canGiup: (so: string) => `Cần giúp? Gọi SAPA: ${so}`,
  rescheduled: 'Đã đổi giờ',
  rescheduledFrom: 'giờ cũ',
  // N1: duyệt lịch khách tự đặt, lý do huỷ, xác nhận "vẫn đến", cần nhắc.
  approveBooking: 'Nhận lịch',
  rejectBooking: 'Từ chối',
  confirmReject:
    'Từ chối lịch này? Khách thấy lý do khi mở trang đặt lịch của tiệm. Số điện thoại sẽ bị ẩn với khách — khách có nút Gọi tiệm.',
  confirmRejectYes: 'Từ chối lịch',
  cancelReasonHint:
    'Khách thấy lý do này khi mở trang đặt lịch của tiệm. Số điện thoại sẽ bị ẩn với khách — khách có nút Gọi tiệm.',
  /** Chữ mờ trong ô (ngắn, không bị cắt); câu đầy đủ là dòng phụ cố định dưới ô (K1a vòng 2). */
  cancelReasonPlaceholder: 'Viết lý do cho khách đọc',
  /** Khi từ chối lịch: câu báo trên ô đã nói số điện thoại bị ẩn — dòng dưới ô chỉ nhắc khách thấy lý do. */
  cancelReasonSeen: 'Khách thấy lý do này khi mở trang đặt lịch của tiệm.',
  cancelReasonChips: ['Khách báo bận', 'Thợ nghỉ', 'Tiệm kín giờ này'] as readonly string[],
  attendanceConfirmed: 'Khách đã xác nhận sẽ đến',
  attendanceUnconfirmed: 'Đã nhắc, khách chưa xác nhận',
  customerMessages: 'Khách nhắn tiệm',
  hasCustomerMessage: 'Khách có nhắn tiệm',
  messagesShowAll: (n: number) => (n > 1 ? `Xem đủ ${n} lời nhắn` : 'Xem đủ lời nhắn'),
  messagesCollapse: 'Thu gọn',
  markConfirmed: 'Khách đã xác nhận qua chat',
  remindTitle: 'Cần nhắc',
  remindHint: 'Bấm “Chép tin & mở Zalo”, dán vào khung chat rồi gửi. Miễn phí.',
  remindAllConfirmed: 'Khách nào cũng đã xác nhận sẽ đến — không cần nhắc thêm.',
  remindCopyOpen: 'Chép tin & mở Zalo',
  remindCopyOnly: 'Chép tin',
  remindDone: 'Đã nhắc',
  remindNone: 'Không còn lịch nào cần nhắc.',
  remindNoPhone:
    'Khách chưa có số Zalo — bấm “Chép tin” rồi gửi cho khách qua kênh tiệm đang dùng.',
  remindCopied: 'Đã chép tin. Dán vào khung chat Zalo rồi gửi nhé.',
  remindCopyFailed: 'Máy chưa cho chép. Bạn giữ tay vào tin để chép nhé.',
  remindFor: (ngay: string) => `Lịch ${ngay}`,
  zaloCheckTitle: 'Zalo mới gắn theo số — đúng người không?',
  zaloCheckHint:
    'Khách dùng Zalo có số trùng hồ sơ tiệm đã nhập. Bấm "Đúng người" thì khách mới xem được gói, ví và lịch sử trong Zalo.',
  // Dòng gập trên màn Tìm khách (vòng 39): số khách Zalo chờ xác nhận, bấm để mở các thẻ.
  zaloCheckOpen: (n: number) => `${n} khách Zalo chờ xác nhận`,
  zaloRight: 'Đúng người',
  zaloWrong: 'Không phải',
  // Hồ sơ chờ SINH TỪ GỘP (ADR-091): nói rõ vì sao chờ, cho một dấu hiệu để đối chiếu, và ai được bấm "Đúng người".
  zaloCheckFromMerge: 'Chờ xác nhận vì vừa được gộp với một hồ sơ có Zalo.',
  zaloCheckSignal: (n: number, ngay: string | null) =>
    ngay === null
      ? `Đã đặt ${n} lịch qua Zalo. Hỏi khách để đối chiếu.`
      : `Đã đặt ${n} lịch qua Zalo, lịch gần nhất ${ngay}. Hỏi khách để đối chiếu.`,
  zaloCheckOwnerOnly: 'Chỉ chủ tiệm hoặc quản lý bấm "Đúng người" được.',
} as const

/** Nhãn tiếng Việt cho trạng thái lịch. Dùng chung để không có hai cách gọi một trạng thái. */
export const TRANG_THAI: Record<string, string> = {
  draft: T.statusDraft,
  pending: 'Chờ duyệt',
  awaiting_deposit: 'Chờ cọc',
  booked: T.statusBooked,
  checked_in: T.statusCheckedIn,
  in_service: T.statusInService,
  done: T.statusDone,
  cancelled: T.statusCancelled,
  no_show: T.statusNoShow,
  // Chỉ gặp ở Danh sách khi lịch hết giờ chờ cọc mà tiền tới muộn (soát N2).
  void: 'Hết giờ giữ chỗ',
}

/** Hành động tiếp theo hợp lệ cho từng trạng thái — khớp với luật ở máy chủ. */
export const HANH_DONG: Record<string, { to: string; label: string; kind: 'primary' | 'ghost' }[]> =
  {
    booked: [
      { to: 'checked_in', label: T.actionCheckIn, kind: 'primary' },
      { to: 'no_show', label: T.actionNoShow, kind: 'ghost' },
      { to: 'cancelled', label: T.actionCancel, kind: 'ghost' },
    ],
    checked_in: [
      { to: 'in_service', label: T.actionStart, kind: 'primary' },
      // Sửa lúc bấm nhầm "Khách đã tới" — máy chủ cho đúng một chiều lùi này.
      { to: 'booked', label: T.actionNotArrived, kind: 'ghost' },
      // V2 (0097): khách đã tới thì không có "Không đến" — lùi "Chưa tới" rồi mới bấm được, hoặc huỷ.
    ],
    in_service: [
      { to: 'done', label: T.actionDone, kind: 'primary' },
      // K4 (Q1): "Chưa bắt đầu" mọi vai quầy (KTV lịch của mình); "Khách về giữa chừng" chỉ quầy (như Huỷ lịch).
      { to: 'checked_in', label: T.actionNotStarted, kind: 'ghost' },
      { to: 'cancelled', label: T.actionLeftMidway, kind: 'ghost' },
    ],
    draft: [{ to: 'booked', label: T.statusBooked, kind: 'primary' }],
    // N1: khách tự đặt khi tiệm bật "duyệt tay". `nhan` / `tu-choi` đi qua `/duyet`, không qua `/status`.
    pending: [
      { to: 'nhan', label: T.approveBooking, kind: 'primary' },
      { to: 'tu-choi', label: T.rejectBooking, kind: 'ghost' },
    ],
    // N2: 'Đã nhận cọc' nằm trong mục Tiền cọc của tờ chi tiết (cần nhập số tiền), không ở nút nhanh.
    awaiting_deposit: [{ to: 'cancelled', label: T.actionCancel, kind: 'ghost' }],
  }

/**
 * Hành động của MỘT lịch cụ thể. K10 (v0.22.2): giữ chỗ (`draft`) của khách tự đặt trên Zalo (nguồn `miniapp`) thì quầy không chốt hộ "Đã đặt" — chờ khách chốt hoặc
 * tự nhả sau 7 phút; giữ chỗ do quầy tạo (`counter`) vẫn "Đã đặt" được. Máy chủ cũng chặn (409), đây chỉ để không mời bấm nút vô ích.
 */
export function hanhDongCua(status: string, nguon?: string): (typeof HANH_DONG)[string] {
  if (status === 'draft' && nguon === 'miniapp') return []
  return HANH_DONG[status] ?? []
}
